import React from 'react';
import './Testimonials.css';

const testimonials = [
    { text: "Świetny warsztat! Naprawili moją hybrydę w jeden dzień. Polecam!", name: "Marek Zieliński", rating: 5 },
    { text: "Profesjonalne podejście i uczciwe ceny. Naprawa silnika wykonana perfekcyjnie.", name: "Katarzyna Lewandowska", rating: 5 },
    { text: "Szybka diagnostyka, pomocny personel. Teraz tylko tutaj serwisuję auto.", name: "Tomasz Wiśniewski", rating: 5 }
];

const Testimonials = () => {
    return (
        <section id="testimonials" className="testimonials">
            <div className="container">
                <div className="section-title">Co mówią nasi klienci</div>
                <div className="section-subtitle">Opinie zadowolonych kierowców</div>
                <div className="testimonials-grid">
                    {testimonials.map((testimonial, index) => (
                        <div className="testimonial-card" key={index}>
                            <i className="fas fa-quote-left"></i>
                            <p>"{testimonial.text}"</p>
                            <div className="stars">{'★'.repeat(testimonial.rating)}</div>
                            <h4>- {testimonial.name}</h4>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;